/**
 *
 * @param string
 * @returns Uppercases the first letter.
 */
export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 *
 * @param string
 * @returns Uppercases the first letter of all words.
 */
export const titleize = (string: string) => {
  return string.replace(/\w\S*/g, (txt) => capitalizeFirstLetter(txt))
}
